<template>
    <v-tabs
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>
        <v-tab key="Categorie" ripple class="secondary-tab">
            Categorie
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-1" key="Campi">
            <v-row class="ma-0">
                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector model-def="vehicleexpiration"></fields-selector>
                </v-col>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
            <v-row class="ma-0">
                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector model-def="vehicleexpiration"></actions-selector>
                </v-col>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Categorie">
            <v-row class="ma-0">
                <v-col class="pa-0 pb-4" cols="12">
                    <crud
                        title="Tipo Scadenza Veicolo"
                        action-icon='settings'
                        model-def='generaltypes-vehicle_expiration_type'
                        action-position='absolute'
                        crudDialog
                    ></crud>
                </v-col>
            </v-row>
        </v-tab-item>
    </v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'

	export default {
		name:'vehicle-expirations-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
        },
		data() {
			return {

			}
		},
	}
</script>
